import React, { useState, useEffect } from "react";
import "./Header.css";
import { Modal } from "react-bootstrap";
import { logoUrl } from "../../Utils/StaticURLs";
import { getSchoolName, getSchoolLocation } from "../../Utils/Utils";
import { Button } from "react-bootstrap";
import { ExistStoreBuilderModal } from "../modals/ExistStoreBuilderModal";
import { AlertsList } from '../Alerts/alertsList';
const Header = (props) => {
  const [iconFlag, seticonFlag] = useState(false);

  const OptionSelect = () => {
    seticonFlag(true);
  };
  const [schoolName, setSchoolName] = useState();
  const [startPopUp, setStartPopUp] = useState({
    heading: "",
    body: "",
    popFlag: false,
  });
  const [existStoreBuilderModalShow, setexistStoreBuilderModalShow] = useState(
    false
  );
  const [schoolLoc, setSchoolLoc] = useState();

  useEffect(() => {
    setSchoolName(getSchoolName());
    setSchoolLoc(getSchoolLocation());
  }, []);

  const handlePopUp = () => {
    seticonFlag(true);
    setStartPopUp({
      heading: props.startOver && props.startOver.title,
      body: props.startOver && props.startOver.info,
      popFlag: true,
    });
  };

  const handleModelHide = () => {
    seticonFlag(false);
    setStartPopUp({ popFlag: false });
  };

  const handleRefresh = () => {
    let origin = window.location.href.split('?')[0];
    window.open(origin, "_self");
  };
  return (
    <>
      <div id="jos-slim-header">
        <div>
          <a href="/" id="jos-logo">
            <img src={logoUrl} alt="Jostens" />
          </a>
          <div className="jos-customer-info">
            <div>
              <div className="jos-customer-name">
                {" "}
                {schoolName ? schoolName : ""}
                <br />
              </div>
              <div className="jos-customer-location">
                {schoolLoc ? schoolLoc : ""}
              </div>
            </div>
          </div>
        </div>
        <div className="header-action-buttons-desktop">
          <div id="start-over-btn" className="cursor-pointer" onClick={() => handlePopUp()}>
            {" "}
            <i className="fal fa-redo"></i>{" "}
            {(props.data && props.data.startOver) || ""}
          </div>
          |
          <div
            id="exit-builder-btn" className="cursor-pointer"
            onClick={() => setexistStoreBuilderModalShow(true)}
          >
            <i className="fal fa-times-circle"></i> &nbsp;
            {(props.data && props.data.exitStole) || ""}
          </div>
        </div>
      </div>
      <div className="row header">
        <div className="col">
          <h2 className="headerLeft">
            {props.selectedStage === "stole-design"
              ? props.data.builderName
              : `${(props.data && props.data.builderVariantPrefix) || ""} ${
                  props.selectedTemplate !== null
                    ? (props.selectedTemplate &&
                        props.selectedTemplate.product &&
                        props.selectedTemplate.product.templateVariant &&
                        props.selectedTemplate.product.templateVariant.toUpperCase() +
                          " " +
                          props.data.version) ||
                      ""
                    : null
                } `}
          </h2>
        </div>
        <div className="col">
          <h2 className="headerRight">
            ${props.estimatedPrice && props.estimatedPrice.toFixed(2)}{" "}
            {(props.data && props.data.estimateSuffix) || ""}
          </h2>
        </div>
      </div>
      <div className="row view-product-details">
        <div className="col view-product-details-title">
          <span>{props.data && props.data.infoLabelLeft}</span>
          &nbsp;
          <span>
            <i
              id="infoIcon"
              className="fas fa-info-circle"
              onClick={() => OptionSelect()}
            ></i>
          </span>
        </div>
      </div>

      <Modal
        id="modal"
        onHide={() => handleModelHide()}
        show={iconFlag}
        dialogClassName={`${startPopUp.popFlag ? "modal-md modal-box":"modal-lg"}`}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header id="modalHeader" closeButton>
        <h4>{startPopUp.popFlag ? startPopUp.heading : props.data && props.data.productToolTipHeader}</h4>     
         </Modal.Header>        
        <Modal.Body>       
          {startPopUp.popFlag ? (
            <div id="startOverDiv">
              <p> {startPopUp.body} </p>
            </div>
          ) : (
            // <div
            //   id="contentDiv"
            //   dangerouslySetInnerHTML={{ __html: content }}
            // />
            `${props.data && props.data.productToolTip}`
          )}
        </Modal.Body>
        <Modal.Footer>
          {startPopUp.popFlag ? (
            <div>
              <Button
                variant="white"
                className="modal-btn"
                onClick={() => handleRefresh()}
                id="startOverButton"
              >
                {props.startOver && props.startOver.leftBtn}
              </Button>
              <Button
                variant="white"
                className="modal-btn"
                onClick={() => handleModelHide()}
                id="continueButton"
              >
                {(props.startOver && props.startOver.rightBtn) || ""}
              </Button>
            </div>
          ) : (
            <div />
          )}
        </Modal.Footer>
      </Modal>
      <ExistStoreBuilderModal
        show={existStoreBuilderModalShow}
        onHide={() => setexistStoreBuilderModalShow(false)}
        saveto={() => {
          props.saveDesignFromModalShow(true);
          setexistStoreBuilderModalShow(false);
        }}
        exitstorejsontext={props.exitStoleAlert}
      />
    </>
  );
};
export default Header;
